// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__25L77","label":"style_label__3jY-H"};